import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterCarStatus"
    ,pure: false
})
export class FilterCarStatus implements PipeTransform {
    transform(items : any[],filter:string,isReverse:boolean) {
        if(!items || !filter){
            return items;
        }

        return items.filter((val,idx) => {
            let isShow = isReverse || false;
            switch(filter){
                case "on":
                    if(val.dtgKeyonYn === "1"){
                        return !isShow;
                    }
                    break;
                case "off":
                    if(val.dtgKeyonYn === "0"){
                        return !isShow;
                    }
                    break;
                case "error":
                    if(
                           val.dtgGpsFaultYn === "1"
                        || val.dtgSpeedFaultYn === "1"
                        || val.dtgRpmFaultYn === "1"
                        || val.dtgBrakeFaultYn === "1"
                        || val.dtgInputFaultYn === "1"
                        || val.dtgOutputFaultYn === "1"
                        || val.dtgSaveFaultYn === "1"
                        || val.dtgCommFaultYn === "1"
                        || val.dtgDistFaultYn === "1"
                        || val.dtgPowerFaultYn === "1"
                    ){
                        return !isShow;
                    }
                    break;
                case "all":
                default:
                    return !isShow;
            }
            return isShow;
        });
    }
}